<template>
  <div>
    <h2>Authentifizierung läuft...</h2>
  </div>
</template>

<script>
export default {
  name: "SignIn",
  async mounted() {
    console.log("SignIn component mounted - handling redirect");

    try {
      // Wait for MSAL initialization which already handles the redirect
      const response = await this.$azure.initPromise;

      if (response) {
        console.log("Login successful after redirect");
        // Redirect to home after successful login
        this.$router.push("/");
      } else {
        console.log("No redirect response - checking if logged in");
        // No response means we're not coming back from a redirect
        if (this.$azure.isLoggedIn()) {
          console.log("Already logged in, redirecting to home");
          this.$router.push("/");
        } else {
          console.log("Not logged in, redirecting to login page");
          this.$router.push("/login");
        }
      }
    } catch (error) {
      console.error("Sign-in error:", error);
      this.$router.push("/login");
    }
  },
};
</script>
